import { render, staticRenderFns } from "./FrzChamberPalletInTunnelDetail.vue?vue&type=template&id=417f01da"
import script from "./FrzChamberPalletInTunnelDetail.vue?vue&type=script&lang=js"
export * from "./FrzChamberPalletInTunnelDetail.vue?vue&type=script&lang=js"
import style0 from "./FrzChamberPalletInTunnelDetail.vue?vue&type=style&index=0&id=417f01da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports